import moment from 'moment-timezone';

export default (offset = 0) => {
  const totalOffset = moment().utcOffset() - offset;
  return `${totalOffset >= 0 ? '%2B' : '-'}${Math.floor(Math.abs(totalOffset / 60))
    .toString()
    .padStart(2, '0')}:${(Math.abs(totalOffset) % 60).toString().padStart(2, '0')}`;
};
